function processButtonClick() {
    let elemYearButton = document.getElementById("yearButton");
    elemYearButton.addEventListener('click', function () {
        let elemYearSelect = document.getElementById("yearSelect");
        let yearValue = elemYearSelect.value;

        // URL作成
        let url = window.location.protocol + "//" + window.location.host;
        let pathSegments = window.location.pathname.split("/").filter(function (segment) {
            return !(segment === "");
        });
        pathSegments.pop();
        for(let i = 0; i < pathSegments.length; i++) {
            url = url + "/" + pathSegments[i];
        }
        let transitionTarget = "/index";
        url = url + transitionTarget;

        // 未選択
        if (!(yearValue === "")) {
            let queryString = "?year_filter=" + yearValue;
            url = url + queryString;
        }

        window.location.href = url;
        return 0;
    });
    return 0;
}

export function fiscalYearFilter() {
        // URLのパス部分を取得する
    let pathSegments = window.location.pathname.split("/").filter(function (segment) {
        return !(segment === "");
    });
    // 配列の最後の値を取得する
    let lastIndex = pathSegments.length - 1;

    // 配列の最後の値を取得
    let lastPathName = pathSegments[lastIndex];

    if (lastPathName === "index") {
        processButtonClick();
    }
}
